import { css } from '@emotion/css'
import colors from '@styles/colors';

import { mobileOnly, tabletPortraitUp, tabletLandscapeUp, desktopUp } from '@styles/breakpoints';

export var loaderCss = css`
    .loader {
        visibility: hidden;
        font-size: 10px;
        text-indent: -9999em;
        border-radius: 50%;
        background: #ffffff;
        background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
        background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
        background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
        background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
        background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
        position: relative;
        -webkit-animation: load3 1.4s infinite linear;
        animation: load3 1.4s infinite linear;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        height: 28px;
        width: 28px;
        margin-top: -6px;
        margin-left: 16px;
        display: none;
        position: absolute;

        &:before {
            width: 50%;
            height: 50%;
            background: #ffffff;
            border-radius: 100% 0 0 0;
            position: absolute;
            top: 0;
            left: 0;
            content: '';
        }

        &:after {
            background: #ecedf0;
            width: 75%;
            height: 75%;
            border-radius: 50%;
            content: '';
            margin: auto;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
    }
    .loader.active {
        visibility: visible;
        display: block;
    }

    @-webkit-keyframes load3 {
        0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        }
        100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
        }
    }
    @keyframes load3 {
        0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        }
        100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
        }
    }`;

export default {
    boxContainer: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',

        '.arrow-back': {
            margin: '3px 6px 3px 0',
            display: 'block',
            borderTop: `3px solid ${colors.BLUE}`,
            borderRight: `3px solid ${colors.BLUE}`,
            WebkitTransform: 'rotate(-135deg)',
            MsTransform: 'rotate(-135deg)',
            transform: 'rotate(-135deg)',
            height: 11,
            width: 11,
            transition: 'border-color 0.2s ease',
            left: 30,
            position: 'absolute',

            [desktopUp]: {
                display: 'none',
            }
        },

        '.boxes': {
            flexGrow: 1,
            backgroundColor: colors.PICK_A_PLAN_CONTAINER,
        },

        '.box-content-wrap': {
            flexGrow: 1,
            backgroundColor: colors.PICK_A_PLAN_CONTAINER,
            overflow: 'hidden auto',
            scrollbarColor: `${colors.BLUE_LIGHTER} #F7F8FB`,
            scrollbarWidth: 'thin',

            '&::-webkit-scrollbar': {
                width: 19,
                height: 300,
            },

            '&::-webkit-scrollbar-thumb': {
                background: colors.BLUE_LIGHTER,
                borderRight: `15px solid #F7F8FB`,
                borderTop: `10px solid #F7F8FB`,
                borderBottom: `10px solid #F7F8FB`,
                backgroundClip: 'padding-box',
            },

            '&::-webkit-scrollbar-button': {
                width: 0,
                height: 0,
                display: 'none',
            },

            '&::-webkit-scrollbar-corner': {
                backgroundColor: 'transparent',
            },

            h4: {
                marginBottom: 20,
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: 13,
                textAlign: 'center',
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
            },

            '.change-size': {
                [mobileOnly]: {
                    button: {
                        position: 'relative',
                        top: -11,
                        marginTop: 10,
                    },
                },
            },
        },

        '.box-content': {
            backgroundColor: colors.WHITE,
            border: '1px solid #EBEEF6',
            borderRadius: 5,
            padding: 20,
            marginLeft: 24,
            marginRight: 24,

            [mobileOnly]: {
                marginBottom: 80,
            },

            [tabletPortraitUp]: {
                minHeight: 557,
                marginBottom: 50,
            },

            '.box-info': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                alignItems: 'flex-end',

                [mobileOnly]: {
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    alignContent: 'flex-start',
                },

                '.blueprint': {
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: 16,
                    lineHeight: '145%',

                    span: {
                        marginRight: 12,
                    },

                    b: {
                        fontWeight: 'bold',
                    }
                },

                button: {
                    fontSize: '13px !important',
                    color: `${colors.BLUE}  !important`,
                }
            },

            '.box-header': {
                '.box-actions': {
                    textAlign: 'right',

                    '.box-action': {
                        fontWeight: 600,
                        fontSize: 13,
                        lineHeight: '115%',
                        letterSpacing: '0.01em',
                        textDecorationLine: 'underline',
                        cursor: 'pointer',
                        color: colors.BLUE,
                        display: 'inline-block',
                        marginLeft: 25,

                        '&:hover': {
                            color: colors.NAVY,
                        },

                        '&:first-child': {
                            marginLeft: 0,
                        },
                    },
                },
            },

            '.products': {
                marginTop: 35,

                table: {
                    width: '100%',
                    borderSpacing: 0,

                    tbody: {
                        tr: {
                            '&.outofstock': {
                                background: colors.RED_LIGHT,

                                '.tags': {
                                    position: 'static',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    alignContent: 'center',
                                    flexWrap: 'nowrap',
                                    height: '100% !important',
                                    minHeight: 70,
                                }
                            },
                            td: {
                                padding: 9,
                                borderTop: '1px solid #EBEEF6',
                                userSelect: 'none',
                                [mobileOnly]: {
                                    padding: 6,
                                },

                                '&.image': {
                                    padding: 6,
                                    textAlign: 'center',

                                    'img': {
                                        maxWidth: 50,
                                        maxHeight: 50,
                                    },

                                    [mobileOnly]: {
                                        // padding: '10px 6px 9px 18px',
                                    }
                                },

                                '&.title': {
                                    fontSize: '15px',
                                    lineHeight: '135%',
                                    fontWeight: 'normal',
                                    letterSpacing: '0.02em',
                                    [mobileOnly]: {
                                        fontSize: 13,
                                    }
                                },

                                '&.count': {
                                    width: 140,
                                    [mobileOnly]: {
                                        width: 145,
                                        paddingRight: 23,
                                    }
                                },

                                '&.price': {
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    lineHeight: '135%',
                                    textAlign: 'right',
                                    letterSpacing: '0.02em',
                                    color: colors.BLUE,
                                    paddingRight: 0,

                                    [mobileOnly]: {
                                        fontSize: '15px',
                                        paddingRight: 23,
                                    }
                                },
                            },
                        },
                    },

                    tfoot: {
                        td: {
                            fontWeight: 600,
                            fontSize: 15,
                            paddingTop: 10,
                            paddingBottom: 10,
                            lineHeight: '135%',
                            letterSpacing: '0.02em',
                            borderTop: '1px solid #EBEEF6',

                            '&.total': {
                                color: colors.BLUE,
                                fontStyle: 'normal',
                                fontWeight: 'bold',
                                fontSize: 13,
                                display: 'flex',
                                alignItems: 'center',
                                letterSpacing: '0.2em',
                                textTransform: 'uppercase',
                            },

                            '&.price': {
                                textAlign: 'right',
                                color: colors.GREEN_BRIGHT,

                                '.no-discount': {
                                    color: colors.BLUE,
                                    textDecorationLine: 'line-through',
                                    display: 'inline-block',
                                    marginRight: 8,
                                },

                                [mobileOnly]: {
                                    paddingRight: 23,
                                }
                            },
                        },
                    },
                },
            },

            '.products-empty': {
                display: 'none',
                marginTop: 60,
                textAlign: 'center',

                div: {
                    marginTop: 40,
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: 15,
                    textAlign: 'center',
                    letterSpacing: '0.02em',
                    color: colors.BLUE,
                    maxWidth: 258,
                    margin: 'auto',
                    lineHeight: 'initial',
                },
            },

            '.box-blueprint-progress': {
                paddingTop: 20,
                width: '100%',

                'table': {
                    width: '100%',
                },

                '.progress-text': {
                    color: colors.BLUE,
                    fontWeight: 600,
                    fontSize: 15,
                    lineHeight: '135%',
                    letterSpacing: '0.02em',

                    '.progress-text-count': {
                        color: colors.GREEN_BRIGHT,
                    },
                },

                '.progress-bar': {
                    height: 5,
                    marginTop: 0,
                    backgroundColor: colors.BLUE_EXTRA_LIGHT,
                    borderRadius: 10,
                    overflow: 'hidden',

                    '.progress-bar-fill': {
                        backgroundColor: colors.RED,
                        borderRadius: 10,
                        height: '100%',
                    },
                },

                '&.allowed': {
                    '.progress-text-count': {
                        color: colors.GREEN_BRIGHT,
                    },

                    '.progress-bar-fill': {
                        backgroundColor: colors.GREEN_BRIGHT,
                    }
                },
            },
        },

        '.remove-button': {
            paddingBottom: 20,
            backgroundColor: colors.PICK_A_PLAN_CONTAINER,
            'button': {
                fontSize: '13px !important',
                paddingBottom: 2,
            },
        },

        '&.empty': {
            '.products-empty': {
                display: 'block',
                marginTop: 80,
                marginBottom: 110,
                width: '100%',
                maxWidth: 278,
                marginLeft: 'auto',
                marginRight: 'auto',
            },

            '.products-not-empty': {
                display: 'none !important',
            },
        },


        '.action-button-wrap': {
            position: 'sticky',
            bottom: 0,
            zIndex: 2,
            marginTop: 20,
            marginBottom: 10,

            [mobileOnly]: {
                padding: '15px 24px',
                backgroundColor: colors.WHITE,
                boxShadow: 'rgba(21, 32, 107, 0.05) 0 -2px 8px',
                marginTop: 0,
                marginBottom: 0,
            },

            button: {
                width: '100%',
                border: 'none',
                padding: 20,
                borderRadius: '0 !important'
            },
        },

        '.swap-message': {
            fontWeight: 400,
            fontSize: 12,
            textAlign: 'center',
            width: '100%',
            padding: 15,
            color: colors.GREEN_BRIGHT,
            backgroundColor: '#EBF5F0',
            marginBottom: '-20px',
            marginTop: 20,
        },

        '.oos-message': {
            fontWeight: 400,
            fontSize: 12,
            textAlign: 'center',
            width: '100%',
            padding: 15,
            color: colors.RED,
            backgroundColor: colors.PINK_EXTRA_LIGHT,
            marginBottom: '-20px',
            marginTop: 20,
        },

        [mobileOnly]: {
            '.oos-message, .swap-message': {
                marginBottom: 0,
            }
        },

        '.action': {
            bottom: 0,
            width: '100%',
            padding: '20px 0px',
            backgroundColor: colors.BLUE,
            color: colors.WHITE,
            fontWeight: 600,
            fontSize: '13px',
            lineHeight: '16px',
            textAlign: 'center',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            zIndex: 2,
            border: 0,
            outline: 0,
            // because of the fuking spinner. I lost like 2 hours on this, sorry don't wanna deal
            // with it any ingle second more
            // transition: 'background-color 0.2s ease',
            [mobileOnly]: {
                padding: '14px 0px',
                maxWidth: '100%',
                borderRadius: 5,
            },

            '&:hover': {
                backgroundColor: colors.NAVY,
            },

            '&:disabled': {
                color: colors.BLACK_LIGHT_65,
                backgroundColor: '#ecedf0',
                cursor: 'initial',
            },

            '&.red': {
                backgroundColor: colors.RED,

                '&:hover': {
                    backgroundColor: colors.RED_DARK,
                },

                '&:disabled': {
                    // color: colors.BLACK_LIGHT_65,
                    backgroundColor: '#ecedf0',
                    cursor: 'initial',
                },
            }
        },
    }),
};
